<ion-backdrop (ionBackdropTap)="doRefresh($event)" *ngIf="isRunEnabled && pageDataRefreshRequired"></ion-backdrop>
<div id="refresh-icon" *ngIf="isRunEnabled && pageDataRefreshRequired">
    <img src="assets/img/reload.svg" alt="reload"
         class="touch-eff-radius" (click)="doRefresh($event)">
</div>
<ion-content class="theme-{{userService.theme}}">
    <ion-header><app-header></app-header></ion-header>
    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div class="details-wrap page-width-and-shadow">
        <div class="content-wrap">
            <div class="box">
                <div class="my-color-blue">{{'__ELEARNING_ELEARNING__' | translate}}</div>
                <app-inline-svg class="icon" [file]="'assets/img/footer/monitor.svg'"></app-inline-svg>
            </div>

            <div class="title">{{'__ELEARNING_OVERVIEW_PROGRAMME__' | translate}}
                <ng-container
                        *ngIf="pageData && pageData.run.enabled">{{'__ELEARNING_LAUNCH_PROGRAMME__' | translate}}</ng-container>
            </div>
            <hr>

            <ng-container>
                <div class="item" [@enter] [@leave] >
                    <div class="element" *ngIf="pageDataValid">
                        <div>
                            <div class="i-title">{{pageData.program.title}}</div>

                            <div class="line">
                                <div class="green">{{'__ELEARNING_AVAILABLE_FROM__' | translate}}</div>
                                {{pageData.program.availableFrom}}
                            </div>
                            <div class="line">
                                <div class="red">{{'__ELEARNING_COMPLETED_BY__' | translate}}</div>
                                {{pageData.program.completedBy}}
                            </div>
                        </div>
                        <img *ngIf="isRunEnabled && !pageDataRefreshRequired" src="assets/img/press.svg" alt="press"
                             class="touch-eff-radius" (click)="openCourse()">
                        <img *ngIf="isRunEnabled && pageDataRefreshRequired" src="assets/img/reload.svg" alt="reload"
                             class="touch-eff-radius" (click)="doRefresh($event)">
                    </div>

                    <div class="element" *ngIf="!pageDataValid">
                        <div style="width:80%">
                            <ion-skeleton-text class="i-title" animated></ion-skeleton-text>
                            <div class="line">
                                <ion-skeleton-text class="green" animated></ion-skeleton-text>
                            </div>
                            <div class="line">
                                <ion-skeleton-text class="red" animated></ion-skeleton-text>
                            </div>
                        </div>
                        <ion-skeleton-text class="run" animated></ion-skeleton-text>
                    </div>

                    <div class="group" *ngIf="pageDataValid">
                        <div class="el rise">
                            <div class="small-text">{{ "__ELEARNING_STATUS__" | translate }}</div>
                            <div *ngIf="pageDataValid"
                                 class="text result-{{pageData.result.resultClass}}">{{pageData.result.status === 'Completed' ? 'Completed' : 'Incomplete'}}</div>
                            <div *ngIf="!pageDataValid" class="text">
                                <ion-skeleton-text animated style="width: 10rem"></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el" *ngIf="false">
                            <div class="small-text">{{'__ELEARNING_RESULT__' | translate}}</div>
                            <div *ngIf="pageDataValid"
                                 class="text result-{{pageData.result.resultClass}}">{{pageData.result.result}}</div>
                            <div *ngIf="!pageDataValid" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el" *ngIf="false">
                            <div class="small-text">{{'__ELEARNING_SCORE__' | translate}}</div>
                            <div *ngIf="pageDataValid" class="text">{{pageData.result.score}}</div>
                            <div *ngIf="!pageDataValid" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el" *ngIf="false">
                            <div class="small-text">{{'__ELEARNING_PASS__' | translate}}</div>
                            <div *ngIf="pageDataValid" class="text">{{pageData.result.pass}}</div>
                            <div *ngIf="!pageDataValid" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el" *ngIf="false">
                            <div class="small-text">{{'__ELEARNING_ATTEMPTS__' | translate}}</div>
                            <div *ngIf="pageDataValid" class="text">{{pageData.result.attempt}}</div>
                            <div *ngIf="!pageDataValid" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el" *ngIf="false">
                            <div class="small-text">{{'__ELEARNING_MAX__' | translate}}</div>
                            <div class="text">{{pageData.program.max}}</div>
                        </div>
                    </div>
                    <hr>
                </div>

                <div class="text" *ngIf="pageDataValid" [innerHTML]="pageData.program.description" [@enter] [@leave]></div>

                <div class="text my-color-red" *ngIf="false && pageDataValid && !isRise" [innerHTML]="('__ELEARNING_COURSE_OBJECTIVES__' | translate)" [@enter]
                     [@leave]></div>
            </ng-container>
        </div>
    </div>
</ion-content>
